define(function () {
	const GenericCollection = require('civicsBase/generic_collection');
	const ScenarioModel = require('civicsModels/portal/scenario_model');
	const InstrumentModel = require('civicsModels/portal/instrument');
	const ApplicationModel = require('civicsModels/application_model');
	const ViewManager = require('civicsUtils/view_manager');
	const Wizard = require('civicsModels/portal/wizard_model');
	const CN = require('civicsUtils/constants');
	var projectParse = function (data) {
		for (i = 0; i < data.length; i++) {
			// if this is a project
			if (data[i].applicationType.code.toUpperCase().trim() == ViewManager.globalConfig().get('wizardProjectType').toUpperCase().trim()) {
				data[i].sortDatetime = data[i].addedDateTime;
				data[i].computedDescription = data[i].projectPhaseName.toLowerCase();
			}
			else {
				data[i].sortDatetime = data[i].addedDateTime;
				data[i].computedDescription = Handlebars.helpers['global:computedDescription'](data[i].portalDescription, data[i].description).toLowerCase();
			}
		}
		return data;
	};

	var parse = function (data) {
		for (i = 0; i < data.length; i++) {
			data[i].sortDatetime = data[i].addedDateTime;
			data[i].computedDescription = Handlebars.helpers['global:computedDescription'](data[i].portalDescription, data[i].description).toLowerCase();
		}
		return data;
	};

	var srParse = function (data) {
		for (i = 0; i < data.length; i++) {
			if (data[i].resolution
				&& data[i].resolution.code
				&& data[i].resolution.code != ''
				&& data[i].resolution.code != ' ') {
				data[i].status = 'Closed';
			} else {
				data[i].status = 'Open';
			}
			data[i].sortDatetime = data[i].applicationDateTime;
			data[i].computedDescription = Handlebars.helpers['global:computedDescription'](data[i].requestType.portalDescription, data[i].requestType.description).toLowerCase();
		}
		return data;
	};

	var instParse = function (data) {
		for (i = 0; i < data.length; i++) {
			data[i].sortDatetime = data[i].addedDateTime;
			try {
				var el = JSON.parse(data[i].instrumentData);
				data[i].computedDescription = el.applicationDescription.toLowerCase();
			} catch(e){
				data[i].computedDescription = ''.toLowerCase();
			}

			// }
		}
		return data;
	};

	var scenarioParse = function (data) {
		for (i = 0; i < data.length; i++) {
			data[i].sortDatetime = data[i].addedDateTime;
			data[i].computedDescription = data[i].name.toLowerCase();
		}
		return data;
	};

	var setWizardProperty = function (parent, scenarioId){
		parent.wizard = new Wizard();
		// type can be either scenario driven or config(wizard type) driven
		parent.wizard.type = 'scenarios';
		parent.wizard.typeId = scenarioId;
	};

	var filterLogLinks = function (loglinks, instType, status) {
		var isCust = false;
		var isPublic = false;
		if (!loglinks) {
			loglinks = [];
		}
		instType = !instType ? '' : instType.toLowerCase();
		status = !status ? '' : status;
		for (var i = 0; i < loglinks.length; i++) {
			if (status == loglinks[i].statusCode && instType != 'servicerequest') {
				loglinks.splice(i, 1);
				i--;
			}
			else if (loglinks[i].isInMyProjects == false) {
				loglinks.splice(i, 1);
				i--;
			}
		}
		return loglinks;
	};

	return GenericCollection.extend({
		processScenarioProject:function(wizardProjectType,ensureParentProject=true){
			var removeThese = [];
			_.forEach(this.models, el=>{
				var wizard = el.get('instrumentType').toLowerCase() == 'projectapplication' && el.get('instrumentSubType').toLowerCase().trim() == wizardProjectType;
				if (!wizard && this.belongToProject(el)){
					var parent = this.findScenarioProject(el,wizardProjectType);
					if ( !parent && ensureParentProject ){
						//create project that has limited feature
						parent = this.addParentProject(el,wizardProjectType);
					}
					else if ( ensureParentProject ){
						this.validateWizardData(parent,el);
					}
					if( parent )
					{
						if(!parent.get('childInstruments')){
							parent.set({
								childInstruments : []
							});
						}
						parent.get('childInstruments').push(el);
					}

					removeThese.push(el);
				}
			});

			$.each(removeThese,function(index,el){
				this.remove(el);
			}.bind(this));
		},
		belongToProject:function(childInstrument){
			var belong = false;
			if(childInstrument.get('scenario') && childInstrument.get('scenario.id')>1 ){
				belong = true;
			}
			if(childInstrument.get('ParentProject') && childInstrument.get('ParentProject.id')>1 ){
				belong = true;
			}
			return belong;
		},
		// if the project still contain wizard child , the wizard property has to be set to fetch the wizard data
		validateWizardData:function(parent,childInstrument){
			var scenarioId = childInstrument.get('scenario.id');
			if (  scenarioId &&  scenarioId>1 && !(parent.wizard)){
				setWizardProperty(parent,scenarioId);
			}
		},
		addParentProject:function(childInstrument, wizardProjectType){
			var parent = new ApplicationModel();
			var data;
			var scenarioId;
			if(childInstrument.get('scenario') && childInstrument.get('scenario.id')>1 && childInstrument.get('scenario.application.id')>1){
				data = childInstrument.get('scenario.application').toJSON();
				scenarioId =  childInstrument.get('scenario.id');
			}
			if(childInstrument.get('ParentProject') && childInstrument.get('ParentProject.id')>1 ){
				data = childInstrument.get('ParentProject').toJSON();
				data.locationLine1 = childInstrument.get('locationLine1') ? childInstrument.get('locationLine1') : '';
				data.locationLine2 = childInstrument.get('locationLine2') ? childInstrument.get('locationLine2') : '';

				if(!scenarioId) {
					scenarioId = childInstrument.get('ParentProject').get('scenarioId');
				}
			}
			if ( data ) {
				data["instrumentType"] = "ProjectApplication"
				data["_appId"] = "Project|" + data.id;
				data.computedDescription = Handlebars.helpers['global:computedDescription'](data.portalDescription, data.description).toLowerCase();
				//data.isDummy = true;
				data.instrumentSubType = wizardProjectType;
				data.instrumentSubTypeDescription = wizardProjectType;
				parent.set(data);
				parent.isDummy = true
				parent.statusChecks = {}
				parent.statusChecks.fetched = true;
				if(!parent.scenarioId) {
					parent.scenarioId = scenarioId;
				}
				if ( scenarioId ){
					setWizardProperty(parent,scenarioId);
				}
				this.add(parent);
			}
			return parent;
		},
		findScenarioProject:function(childInstrument, wizardProjectType){
			var parent;
			if ( childInstrument ){
				var childProjectId;
				if(childInstrument.get('scenario') && childInstrument.get('scenario.id')>1 && childInstrument.get('scenario.application.id')>1){
					childProjectId = childInstrument.get('scenario.application.id');
				}
				if(childInstrument.get('ParentProject') && childInstrument.get('ParentProject.id')>1 ){
					childProjectId = childInstrument.get('ParentProject.id');
				}
				if ( childProjectId ){
					_.forEach(this.models, el=>{

						if(el.get('instrumentType') && el.get('instrumentType').toLowerCase()=='projectapplication'
							&& el.get('instrumentSubType')
							&& el.get('instrumentSubType').toLowerCase() == wizardProjectType.toLowerCase()
							&& el.get('id') == childProjectId
						){
							parent = el;
						}
					});
				}
			}
			return parent;
		},
		dataTypeContext: [{
			generateId: function(obj, key) {
				// generate unique id and add data type to model
				obj._appId = this.dataType.type + "|" + obj.instrumentType + "|" + obj.id;
				obj._dataType = this.dataType.type;
			},
			type: 'instruments',
			url: 'core/views/instruments',
			collectionParse: function (data) {
				for (i = 0; i < data.length; i++) {
					switch(data[i].instrumentType) {
								case 'BuildingApplication':
									data[i]._cdrType = 'building';
									data[i]._dataType = 'building';
										break;
								case 'BusinessLicense':
										data[i]._cdrType = 'businessLicense';
										data[i]._dataType = 'businessLicense';
										break;
								case 'Case':
										data[i]._cdrType = 'codeEnforcement';
										data[i]._dataType = 'codeEnforcement';
										break;
								case 'PlanningApplication':
										data[i]._cdrType = 'planning';
										data[i]._dataType = 'planning';
										break;
								case 'ProjectApplication':
										data[i]._cdrType = 'project';
										data[i]._dataType = 'project';
										if ( data[i].instrumentSubType.toUpperCase().trim() == ViewManager.globalConfig().get('wizardProjectType').toUpperCase().trim() ){
											data[i].portalDescription = data[i].instrumentName;
										}
										break;
								case 'TradeLicense':
										data[i]._cdrType = 'tradeLicense';
										data[i]._dataType = 'tradeLicense';
										break;
								case 'UseApplication':
										data[i]._cdrType = 'use';
										data[i]._dataType = 'use';
										break;
								case 'ServiceRequest':
										data[i]._cdrType = 'serviceRequest';
										data[i]._dataType = 'serviceRequest';
										// SR status should just be open or close
										data[i].statusDescription = (data[i].status && data[i].status.trim().length > 0) ? i18n.t('CIVICS.COMMON.CLOSED') : i18n.t('CIVICS.COMMON.OPEN');
										break;
								case 'PortalScenario':
										if ( data[i].status && data[i].status.length == 1){
											switch(data[i].status.toUpperCase()) {
										    case 'A':
													data[i].status = 'Active';
										      data[i].statusDescription = CN.SCENARIO_STATUS().Active;
										      break;
										    case 'R':
										      data[i].status = 'ReadyToApply';
													data[i].statusDescription = CN.SCENARIO_STATUS().ReadyToApply;
										      break;
												case 'P':
													data[i].status = 'ApplicationPending';
													data[i].statusDescription = CN.SCENARIO_STATUS().ApplicationPending;
													break;
												case 'Q':
													data[i].status = 'QuestionsPending';
													data[i].statusDescription = CN.SCENARIO_STATUS().QuestionsPending;
													break;
										    default:
												data[i].statusDescription = data[i].status;
										        break;
											}
										}
										data[i].portalDescription = data[i].instrumentName;
										break;
								case 'PortalInstrument':
									data[i].status = i18n.t('CIVICS.COMMON.OPEN');;
									data[i].statusDescription = data[i].status;
									data[i].portalDescription = data[i].instrumentName;
									break;
								default:
										console.log('undefined/invalid product family from the instrument response');
						}
					data[i].computedDescription = Handlebars.helpers['global:computedDescription'](data[i].portalDescription, data[i].description);
					if( data[i].computedDescription.trim().length <= 0 ){
						data[i].computedDescription = i18n.t('CIVICS.COMMON.VALUE_NOT_CONFIG');
					}
					data[i].logLinks = filterLogLinks(data[i].logLinks, data[i]._cdrType, data[i].status);
				}
				return data;
			},
			select: [
				'id',
				'InstrumentType',
				'ProductFamily',
				'Comments',
				'CommonId',
				'InstrumentName',
				'InstrumentNumber',
				'InstrumentSubType',
				'Description',
				'PortalDescription',
				'InstrumentDateTime',
				'AddedDateTime',
				'Status',
				'StatusDescription',
				'LocationLine1',
				'LocationLine2',
				'DisplayLocation',
				'totalFeesCharged',
				'totalUnpaidFees',
				'totalAmountDueNow',
				'totalPortalAmountDueNow',
				'contacts',
				'contacts.contact.identity.firstName',
				'contacts.contact.identity.lastName',
				'CurrentMilestoneCode',
				'InstrumentSubTypeKey',
				'IsClosedInstrument'
			]
		}]
	});
});
